import { Link } from "@tanstack/react-router"

import { cn } from "@/lib/utils"

type ServiceBrandProps = {
  compact?: boolean
  inverted?: boolean
  linkTo?: "/" | "/portal" | "/admin"
  className?: string
}

export function ServiceMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 52 52"
      aria-hidden="true"
      className={cn("shrink-0", className)}
    >
      <rect x="1" y="1" width="50" height="50" rx="13" fill="#123a5a" />
      <path
        d="M26 8.5v35M8.5 26h35"
        stroke="#ffffff"
        strokeWidth="4.2"
        strokeLinecap="round"
      />
      <circle
        cx="26"
        cy="26"
        r="8.5"
        fill="#f2bd3d"
        stroke="#ffffff"
        strokeWidth="2.2"
      />
      <path
        d="M8.8 17.2c5.2-7.5 15-11 24-8.4 6.1 1.8 10.6 6.2 12.4 11.5"
        fill="none"
        stroke="#22b6cf"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <circle cx="44.8" cy="20.3" r="2.7" fill="#ffffff" />
    </svg>
  )
}

export function ServiceBrand({
  compact = false,
  inverted = false,
  linkTo = "/",
  className,
}: ServiceBrandProps) {
  return (
    <Link
      to={linkTo}
      aria-label="Service Portal home"
      className={cn(
        "inline-flex min-w-0 items-center gap-3 rounded-[10px] focus-visible:outline-3 focus-visible:outline-offset-3 focus-visible:outline-[var(--cyan)]",
        className
      )}
    >
      <span
        className={cn(
          "grid shrink-0 place-items-center",
          inverted &&
            "rounded-[14px] bg-white p-1 shadow-[0_8px_20px_-14px_rgba(0,0,0,.72)]"
        )}
      >
        <ServiceMark className={compact ? "size-9" : "size-11"} />
      </span>
      <span className="min-w-0">
        <span
          className={cn(
            "block text-xl leading-none font-bold tracking-[-0.035em]",
            inverted ? "text-white" : "text-[var(--navy)]"
          )}
        >
          Service Portal
        </span>
        {!compact ? (
          <span
            className={cn(
              "mt-1 block max-w-[240px] text-xs leading-[1.2] font-semibold tracking-[0.02em]",
              inverted ? "text-white/70" : "text-[var(--telemetry)]"
            )}
          >
            Earth observation imagery
            <br />
            request workspace
          </span>
        ) : null}
      </span>
    </Link>
  )
}
